<app-loader *ngIf="isLoading; else showForm" class="mt-5"></app-loader>

<ng-template #showForm>
  <app-cms-layout
    [title]="'navigation_my_account' | t"
    [titleHelpText]="'my_account_title_help_text' | t"
    class="w-100"
  >
    <ng-container content>
      <div class="d-flex justify-content-center row mb-5">
        <app-cms-entity-management-inner-section-nav
          class="col-md-2"
          [options]="MY_SETTINGS_SECTIONS"
          [activeOption]="activeMySettingsSection"
        ></app-cms-entity-management-inner-section-nav>
        <div class="col-md-10 my-settings main-padding">
          <div class="my-settings__header">
            <div>
              <h3>{{ "my_settings_personal_details" | t }}</h3>
              <p>{{ "my_settings_personal_details_help_text" | t }}</p>
            </div>

            <div class="my-settings__actions">
              <app-button
                [buttonStyle]="BUTTON_STYLES.ACTION"
                *ngIf="!editMode"
                [buttonSize]="'medium'"
                (click)="onAllowEdit()"
              >
                {{ "edit" | t }}
              </app-button>

              <app-button
                buttonStyle="white-outlined"
                *ngIf="editMode"
                [buttonSize]="'medium'"
                (click)="onCancelEdit()"
              >
                {{ "cancel" | t }}
              </app-button>

              <app-button
                *ngIf="showActionButton"
                [disabled]="!allowSave"
                [buttonSize]="'medium'"
                [buttonStyle]="BUTTON_STYLES.ACTION"
                (click)="submit()"
              >
                {{ "save" | t }}
              </app-button>
            </div>
          </div>
          <!-- TODO: Enable when avatar upload is supported-->
          <div class="d-flex align-items-center" *ngIf="false">
            <app-avatar-input
              class="my-settings__avatar"
              [fc]="innerForm.controls.avatar"
              [disabled]="!canChangeAvatar"
            ></app-avatar-input>

            <span class="my-settings__name"
              >{{ (user$ | async)?.first_name }}
              {{ (user$ | async)?.last_name }}</span
            >
          </div>

          <form [formGroup]="innerForm" (keyup.enter)="$event.preventDefault()">
            <app-input-row [label]="'my_settings_personal_details_name' | t">
              <div class="row">
                <app-input
                  class="col-md-6"
                  [disabled]="!editMode"
                  [fc]="innerForm.controls.first_name"
                  label="First Name"
                ></app-input>

                <app-input
                  class="col-md-6"
                  [disabled]="!editMode"
                  [fc]="innerForm.controls.last_name"
                  label="Last Name"
                ></app-input>
              </div>
            </app-input-row>

            <app-input-row
              [label]="'my_settings_personal_details_gender' | t"
              [labelInfo]="'my_settings_personal_details_gender_info' | t"
            >
              <app-select
                [disabled]="!editMode"
                [fc]="innerForm.controls.sex"
                [options]="genderOptions"
              ></app-select>
            </app-input-row>

            <app-input-row
              [label]="'my_settings_personal_details_date_of_birth' | t"
            >
              <app-date-input
                [minDate]="minDate"
                [maxDate]="maxDate"
                [disabled]="!editMode"
                [fc]="innerForm.controls.date_of_birth"
              ></app-date-input>
            </app-input-row>

            <app-input-row
              [label]="'my_settings_personal_details_location' | t"
            >
              <app-select
                [disabled]="!editMode"
                [fc]="innerForm.controls.country"
                [options]="locationOptions"
              ></app-select>
            </app-input-row>

            <app-input-row [label]="'my_settings_personal_details_phone' | t">
              <app-tel-input
                #telInput
                [disabled]="!editMode"
                [fc]="innerForm.controls.phone_number"
              ></app-tel-input>
            </app-input-row>

            <app-input-row [label]="'my_settings_personal_details_email' | t">
              <app-input
                [disabled]="true"
                [fc]="innerForm.controls.email"
              ></app-input>
            </app-input-row>
          </form>
        </div>
      </div>
    </ng-container>
  </app-cms-layout>
</ng-template>
